export default function initialState () {
  return JSON.parse(sessionStorage.getItem('defaultNotificationConfig'))
}
